import { cn } from '@/lib/utils';

const categoryConfig: Record<string, { text: string; bg: string }> = {
  product:     { text: '#7C3AED', bg: '#EDE9FE' },
  department:  { text: '#2563EB', bg: '#DBEAFE' },
  sla:         { text: '#059669', bg: '#D1FAE5' },
  initiative:  { text: '#D97706', bg: '#FEF3C7' },
  team:        { text: '#DC2626', bg: '#FEE2E2' },
  project:     { text: '#7C3AED', bg: '#EDE9FE' },
};

interface CategoryBadgeProps {
  category: string;
  className?: string;
}

export function CategoryBadge({ category, className }: CategoryBadgeProps) {
  const key = category.toLowerCase();
  const config = categoryConfig[key] ?? { text: '#374151', bg: '#F3F4F6' };
  return (
    <span
      className={cn('inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium', className)}
      style={{ color: config.text, backgroundColor: config.bg }}
    >
      {category.charAt(0).toUpperCase() + category.slice(1)}
    </span>
  );
}
